module.exports = __webpack_public_path__ + "static/media/subICloud1.c7bb5303.png";